import { render, staticRenderFns } from "./SingaporeFlag.vue?vue&type=template&id=112fd841&"
import script from "./SingaporeFlag.vue?vue&type=script&lang=js&"
export * from "./SingaporeFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports